import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from './grid.module';
import { AlertModule } from '../../alert-panel/alert.module';
import { UkMileageRateSettingPanelComponent } from '../../advance-mileage/Panels/uk-mileage-rate-setting-panel/uk-mileage-rate-setting-panel.component';
import { FmInfoEditPanelComponent } from '../../advance-mileage/Panels/fm-info-edit-panel/fm-info-edit-panel.component';
import { SharedModule } from 'src/app/shared.module';
import { ManageVatStepsModule } from './manage-vat-steps.module';
//import { DynamicFormsModule } from './dynamic-forms.module';

@NgModule({
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    GridModule,
    ManageVatStepsModule,
    UkMileageRateSettingPanelComponent,
    //DynamicFormsModule
  ],
  declarations: [
    FmInfoEditPanelComponent,
  ],
  exports: [
    FmInfoEditPanelComponent,
  ]
  ,schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class UkMileageModule { }
